module.exports = __webpack_public_path__ + "37a7c485b133424b37c9de2a1973690e.svg";